
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Treatments from '../pages/treatments/page';
import VirtualPrimaryCare from '../pages/virtual-primary-care/page';
import HormoneOptimization from '../pages/services/hormone-optimization/page';
import PeptideTherapy from '../pages/services/peptide-therapy/page';
import NADTreatment from '../pages/services/nad-treatment/page';
import IVVitaminTherapy from '../pages/services/iv-vitamin-therapy/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/treatments',
    element: <Treatments />
  },
  {
    path: '/virtual-primary-care',
    element: <VirtualPrimaryCare />
  },
  {
    path: '/services/hormone-optimization',
    element: <HormoneOptimization />
  },
  {
    path: '/services/peptide-therapy',
    element: <PeptideTherapy />
  },
  {
    path: '/services/nad-treatment',
    element: <NADTreatment />
  },
  {
    path: '/services/iv-vitamin-therapy',
    element: <IVVitaminTherapy />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
